function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_USERS_REQUEST = "GET_USERS_REQUEST";
export var GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export var GET_USERS_FAILURE = "GET_USERS_FAILURE";
export var loadUsers = function loadUsers(page, size, idFilterValue, emailFilterValue, emailFilterMode, startCreatedAtFilterValue, endCreatedAtFilterValue) {
  return function (dispatch, getState) {
    var queryString = urlSearchParams({
      page: page,
      size: size,
      sort: "createdAt,desc",
      projection: "full",
      idFilterValue: idFilterValue,
      emailFilterValue: emailFilterValue,
      emailFilterMode: emailFilterMode,
      startCreatedAtFilterValue: startCreatedAtFilterValue,
      endCreatedAtFilterValue: endCreatedAtFilterValue
    });
    return dispatch(_defineProperty({
      page: page,
      size: size
    }, CALL_API, {
      types: [GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE],
      endpoint: "users/search/findAll".concat(queryString),
      init: {
        credentials: "same-origin"
      }
    }));
  };
};
export var GET_USERSBYINVESTMENTACCOUNTBROKERID_REQUEST = "GET_USERSBYINVESTMENTACCOUNTBROKERID_REQUEST";
export var GET_USERSBYINVESTMENTACCOUNTBROKERID_SUCCESS = "GET_USERSBYINVESTMENTACCOUNTBROKERID_SUCCESS";
export var GET_USERSBYINVESTMENTACCOUNTBROKERID_FAILURE = "GET_USERSBYINVESTMENTACCOUNTBROKERID_FAILURE";
export var loadUsersByInvestmentAccountBrokerId = function loadUsersByInvestmentAccountBrokerId(page, size, investmentAccountsBrokerId, idFilterValue, emailFilterValue, emailFilterMode, startCreatedAtFilterValue, endCreatedAtFilterValue) {
  return function (dispatch, getState) {
    var queryString = urlSearchParams({
      page: page,
      size: size,
      sort: "createdAt,desc",
      projection: "full",
      investmentAccountsBrokerId: investmentAccountsBrokerId,
      idFilterValue: idFilterValue,
      emailFilterValue: emailFilterValue,
      emailFilterMode: emailFilterMode,
      startCreatedAtFilterValue: startCreatedAtFilterValue,
      endCreatedAtFilterValue: endCreatedAtFilterValue
    });
    return dispatch(_defineProperty({
      investmentAccountsBrokerId: investmentAccountsBrokerId
    }, CALL_API, {
      types: [GET_USERSBYINVESTMENTACCOUNTBROKERID_REQUEST, GET_USERSBYINVESTMENTACCOUNTBROKERID_SUCCESS, GET_USERSBYINVESTMENTACCOUNTBROKERID_FAILURE],
      endpoint: "users/search/findAllByInvestmentAccountBrokerId".concat(queryString),
      init: {
        credentials: "same-origin"
      }
    }));
  };
};
export var GET_USERSBYUSERNAMECONTAINING_REQUEST = "GET_USERSBYUSERNAMECONTAINING_REQUEST";
export var GET_USERSBYUSERNAMECONTAINING_SUCCESS = "GET_USERSBYUSERNAMECONTAINING_SUCCESS";
export var GET_USERSBYUSERNAMECONTAINING_FAILURE = "GET_USERSBYUSERNAMECONTAINING_FAILURE";
export var RESET_GET_USERSBYUSERNAMECONTAINING = "RESET_GET_USERSBYUSERNAMECONTAINING";

// Fetches users by email containing value from Front API.
// Relies on Redux Thunk middleware.
export var fetchUsersByUsernameContaining = function fetchUsersByUsernameContaining(page, size, username) {
  return _defineProperty({}, CALL_API, {
    types: [GET_USERSBYUSERNAMECONTAINING_REQUEST, GET_USERSBYUSERNAMECONTAINING_SUCCESS, GET_USERSBYUSERNAMECONTAINING_FAILURE],
    endpoint: "users/search/findByUsernameContaining".concat(urlSearchParams({
      page: page,
      size: size,
      projection: "public",
      username: username
    })),
    init: {
      credentials: "same-origin"
    }
  });
};

// Fetches users by email containing value from Front API.
// Relies on Redux Thunk middleware.
export var loadUsersByUsernameContaining = function loadUsersByUsernameContaining(page, size, username) {
  return function (dispatch, getState) {
    return dispatch(fetchUsersByUsernameContaining(page, size, username));
  };
};
export var GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_REQUEST = "GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_REQUEST";
export var GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_SUCCESS = "GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_SUCCESS";
export var GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_FAILURE = "GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_FAILURE";
export var RESET_GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING = "RESET_GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING";

// Fetches users by email containing value from Front API.
// Relies on Redux Thunk middleware.
export var loadUsersByInvestmentAccountBrokerIdAndEmailContaining = function loadUsersByInvestmentAccountBrokerIdAndEmailContaining(page, size, investmentAccountsBrokerId, email) {
  return function (dispatch, getState) {
    var queryString = urlSearchParams({
      page: page,
      size: size,
      projection: "publicWithEmail",
      investmentAccountsBrokerId: investmentAccountsBrokerId,
      email: email
    });
    return dispatch(_defineProperty({}, CALL_API, {
      types: [GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_REQUEST, GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_SUCCESS, GET_USERSBYINVESTMENTACCOUNTSBROKERIDANDEMAILCONTAINING_FAILURE],
      endpoint: "users/search/findByInvestmentAccounts_Broker_IdAndEmailContaining".concat(queryString),
      init: {
        credentials: "same-origin"
      }
    }));
  };
};
export var GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_REQUEST = "GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_REQUEST";
export var GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_SUCCESS = "GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_SUCCESS";
export var GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_FAILURE = "GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_FAILURE";
export var RESET_GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL = "RESET_GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL";

// Fetches users by firstName and lastName containing value from Front API unless it is cached.
// Relies on Redux Thunk middleware.
export var fetchUsersByUsernameContainingOrPersonLastNameContainingAndIdNotInAndEnabledAtNotNull = function fetchUsersByUsernameContainingOrPersonLastNameContainingAndIdNotInAndEnabledAtNotNull(page, size, username, personLastName, ids) {
  var queryString = urlSearchParams({
    page: page,
    size: size,
    projection: "public",
    username: username,
    personLastName: personLastName,
    ids: ids
  });
  return _defineProperty({
    username: username,
    personLastName: personLastName,
    ids: ids
  }, CALL_API, {
    types: [GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_REQUEST, GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_SUCCESS, GET_USERSBYUSERNAMECONTAININGORPERSONLASTNAMECONTAININGANDIDNOTINANDENABLEDATNOTNULL_FAILURE],
    endpoint: "users/search/findByUsernameContainingOrPersonLastNameContainingAndIdNotInAndEnabledAtNotNull".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};
export var GET_USERBYID_REQUEST = "GET_USERBYID_REQUEST";
export var GET_USERBYID_SUCCESS = "GET_USERBYID_SUCCESS";
export var GET_USERBYID_FAILURE = "GET_USERBYID_FAILURE";
export var RESET_GET_USERBYID = "RESET_GET_USERBYID";

// Fetches a particular user from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchUserById = function fetchUserById(id) {
  return _defineProperty({
    id: id
  }, CALL_API, {
    types: [GET_USERBYID_REQUEST, GET_USERBYID_SUCCESS, GET_USERBYID_FAILURE],
    endpoint: "users/".concat(id).concat(urlSearchParams({
      projection: "full"
    })),
    init: {
      credentials: "same-origin"
    }
  });
};
export var POST_USER_REQUEST = "POST_USER_REQUEST";
export var POST_USER_SUCCESS = "POST_USER_SUCCESS";
export var POST_USER_FAILURE = "POST_USER_FAILURE";
export var RESET_POST_USER = "RESET_POST_USER";
export var postUser = function postUser(user) {
  return _defineProperty({
    id: user.id
  }, CALL_API, {
    types: [POST_USER_REQUEST, POST_USER_SUCCESS, POST_USER_FAILURE],
    endpoint: "users/".concat(user.id, "?lang=es"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(user),
      credentials: "same-origin"
    }
  });
};
export var postUserFailure = function postUserFailure(message) {
  return {
    response: {
      message: message
    },
    type: POST_USER_FAILURE
  };
};
export var resetPostUser = function resetPostUser() {
  return {
    type: RESET_POST_USER
  };
};
export var POST_USERPROFILEPICTURE_REQUEST = "POST_USERPROFILEPICTURE_REQUEST";
export var POST_USERPROFILEPICTURE_SUCCESS = "POST_USERPROFILEPICTURE_SUCCESS";
export var POST_USERPROFILEPICTURE_FAILURE = "POST_USERPROFILEPICTURE_FAILURE";
export var RESET_POST_USERPROFILEPICTURE = "RESET_POST_USERPROFILEPICTURE";
export var postUserProfilePicture = function postUserProfilePicture(user, profilePicture) {
  return _defineProperty({
    user: user,
    profilePicture: profilePicture
  }, CALL_API, {
    types: [POST_USERPROFILEPICTURE_REQUEST, POST_USERPROFILEPICTURE_SUCCESS, POST_USERPROFILEPICTURE_FAILURE],
    endpoint: "users/".concat(user.id, "/profilePicture"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(profilePicture),
      credentials: "same-origin"
    }
  });
};
export var postUserProfilePictureFailure = function postUserProfilePictureFailure(message) {
  return {
    response: {
      message: message
    },
    type: POST_USERPROFILEPICTURE_FAILURE
  };
};
export var resetPostUserProfilePicture = function resetPostUserProfilePicture(userId) {
  return {
    userId: userId,
    type: RESET_POST_USERPROFILEPICTURE
  };
};
export var POST_USERPROFILEBACKGROUNDPICTURE_REQUEST = "POST_USERPROFILEBACKGROUNDPICTURE_REQUEST";
export var POST_USERPROFILEBACKGROUNDPICTURE_SUCCESS = "POST_USERPROFILEBACKGROUNDPICTURE_SUCCESS";
export var POST_USERPROFILEBACKGROUNDPICTURE_FAILURE = "POST_USERPROFILEBACKGROUNDPICTURE_FAILURE";
export var RESET_POST_USERPROFILEBACKGROUNDPICTURE = "RESET_POST_USERPROFILEBACKGROUNDPICTURE";
export var postUserProfileBackgroundPicture = function postUserProfileBackgroundPicture(user, profileBackgroundPicture) {
  return _defineProperty({
    user: user,
    profileBackgroundPicture: profileBackgroundPicture
  }, CALL_API, {
    types: [POST_USERPROFILEBACKGROUNDPICTURE_REQUEST, POST_USERPROFILEBACKGROUNDPICTURE_SUCCESS, POST_USERPROFILEBACKGROUNDPICTURE_FAILURE],
    endpoint: "users/".concat(user.id, "/profileBackgroundPicture"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(profileBackgroundPicture),
      credentials: "same-origin"
    }
  });
};
export var postUserProfileBackgroundPictureFailure = function postUserProfileBackgroundPictureFailure(message) {
  return {
    response: {
      message: message
    },
    type: POST_USERPROFILEBACKGROUNDPICTURE_FAILURE
  };
};
export var resetPostUserProfileBackgroundPicture = function resetPostUserProfileBackgroundPicture(userId) {
  return {
    userId: userId,
    type: RESET_POST_USERPROFILEBACKGROUNDPICTURE
  };
};
export var POST_USEREXCLUSIONPREFERENCES_REQUEST = "POST_USEREXCLUSIONPREFERENCES_REQUEST";
export var POST_USEREXCLUSIONPREFERENCES_SUCCESS = "POST_USEREXCLUSIONPREFERENCES_SUCCESS";
export var POST_USEREXCLUSIONPREFERENCES_FAILURE = "POST_USEREXCLUSIONPREFERENCES_FAILURE";
export var RESET_POST_USEREXCLUSIONPREFERENCES = "RESET_POST_USEREXCLUSIONPREFERENCES";
export var postUserExclusionPreferences = function postUserExclusionPreferences(user, exclusionPreferences) {
  return _defineProperty({
    user: user,
    exclusionPreferences: exclusionPreferences
  }, CALL_API, {
    types: [POST_USEREXCLUSIONPREFERENCES_REQUEST, POST_USEREXCLUSIONPREFERENCES_SUCCESS, POST_USEREXCLUSIONPREFERENCES_FAILURE],
    endpoint: "users/".concat(user.id, "/exclusionPreferences"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(exclusionPreferences),
      credentials: "same-origin"
    }
  });
};
export var resetPostUserExclusionPreferences = function resetPostUserExclusionPreferences(id) {
  return {
    id: id,
    type: RESET_POST_USEREXCLUSIONPREFERENCES
  };
};
export var POST_USERLANGUAGEPREFERENCES_REQUEST = "POST_USERLANGUAGEPREFERENCES_REQUEST";
export var POST_USERLANGUAGEPREFERENCES_SUCCESS = "POST_USERLANGUAGEPREFERENCES_SUCCESS";
export var POST_USERLANGUAGEPREFERENCES_FAILURE = "POST_USERLANGUAGEPREFERENCES_FAILURE";
export var RESET_POST_USERLANGUAGEPREFERENCES = "RESET_POST_USERLANGUAGEPREFERENCES";
export var postUserLanguagePreferences = function postUserLanguagePreferences(user, languagePreferences) {
  return _defineProperty({
    user: user,
    languagePreferences: languagePreferences
  }, CALL_API, {
    types: [POST_USERLANGUAGEPREFERENCES_REQUEST, POST_USERLANGUAGEPREFERENCES_SUCCESS, POST_USERLANGUAGEPREFERENCES_FAILURE],
    endpoint: "users/".concat(user.id, "/languagePreferences"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(languagePreferences),
      credentials: "same-origin"
    }
  });
};
export var resetPostUserLanguagePreferences = function resetPostUserLanguagePreferences(id) {
  return {
    id: id,
    type: RESET_POST_USERLANGUAGEPREFERENCES
  };
};
export var POST_USERINVESTMENTPREFERENCES_REQUEST = "POST_USERINVESTMENTPREFERENCES_REQUEST";
export var POST_USERINVESTMENTPREFERENCES_SUCCESS = "POST_USERINVESTMENTPREFERENCES_SUCCESS";
export var POST_USERINVESTMENTPREFERENCES_FAILURE = "POST_USERINVESTMENTPREFERENCES_FAILURE";
export var RESET_POST_USERINVESTMENTPREFERENCES = "RESET_POST_USERINVESTMENTPREFERENCES";
export var postUserInvestmentPlanPreferences = function postUserInvestmentPlanPreferences(user, investmentPlanPreferences) {
  return _defineProperty({
    user: user
  }, CALL_API, {
    types: [POST_USERINVESTMENTPREFERENCES_REQUEST, POST_USERINVESTMENTPREFERENCES_SUCCESS, POST_USERINVESTMENTPREFERENCES_FAILURE],
    endpoint: "users/".concat(user.id, "/investmentPlanPreferences"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(investmentPlanPreferences),
      credentials: "same-origin"
    }
  });
};
export var postUserInvestmentPlanPreferencesFailure = function postUserInvestmentPlanPreferencesFailure(message) {
  return {
    response: {
      message: message
    },
    type: POST_USERINVESTMENTPREFERENCES_FAILURE
  };
};
export var resetPostUserInvestmentPlanPreferences = function resetPostUserInvestmentPlanPreferences() {
  return {
    type: RESET_POST_USERINVESTMENTPREFERENCES
  };
};
export var GET_REQUESTDELETEUSER_REQUEST = "GET_REQUESTDELETEUSER_REQUEST";
export var GET_REQUESTDELETEUSER_SUCCESS = "GET_REQUESTDELETEUSER_SUCCESS";
export var GET_REQUESTDELETEUSER_FAILURE = "GET_REQUESTDELETEUSER_FAILURE";
export var RESET_GET_REQUESTDELETEUSER = "RESET_GET_REQUESTDELETEUSER";
export var requestDeleteUser = function requestDeleteUser(userId) {
  return _defineProperty({
    userId: userId
  }, CALL_API, {
    types: [GET_REQUESTDELETEUSER_REQUEST, GET_REQUESTDELETEUSER_SUCCESS, GET_REQUESTDELETEUSER_FAILURE],
    endpoint: "users/".concat(userId, "/requestDelete"),
    init: {
      credentials: "same-origin"
    }
  });
};
export var resetRequestDeleteUser = function resetRequestDeleteUser() {
  return {
    type: RESET_GET_REQUESTDELETEUSER
  };
};
export var GET_CONFIRMDELETEUSER_REQUEST = "GET_CONFIRMDELETEUSER_REQUEST";
export var GET_CONFIRMDELETEUSER_SUCCESS = "GET_CONFIRMDELETEUSER_SUCCESS";
export var GET_CONFIRMDELETEUSER_FAILURE = "GET_CONFIRMDELETEUSER_FAILURE";
export var RESET_GET_CONFIRMDELETEUSER = "RESET_GET_CONFIRMDELETEUSER";
export var confirmDeleteUser = function confirmDeleteUser(userId, token) {
  return _defineProperty({
    userId: userId
  }, CALL_API, {
    types: [GET_CONFIRMDELETEUSER_REQUEST, GET_CONFIRMDELETEUSER_SUCCESS, GET_CONFIRMDELETEUSER_FAILURE],
    endpoint: "users/".concat(userId, "/confirmDelete?token=").concat(token),
    init: {
      credentials: "same-origin"
    }
  });
};
export var resetConfirmDeleteUser = function resetConfirmDeleteUser() {
  return {
    type: RESET_GET_CONFIRMDELETEUSER
  };
};